
// Vue
import { Component, Mixins } from 'vue-mixin-decorator';
// Components
import BasePage from '@/pages/BasePage.vue';

@Component
export default class TermsPage extends Mixins<BasePage>(BasePage) {
  private asctContents: Array<{ label: string; value: string }> = [];

  created() {
    this.asctContents = [
      {
        label: `${this.$t('pages.asctPolicyPage.label.seller')}`,
        value: `${this.$t('pages.asctPolicyPage.value.seller')}`
      },
      {
        label: `${this.$t('pages.asctPolicyPage.label.representative')}`,
        value: `${this.$t('pages.asctPolicyPage.value.representative')}`
      },
      {
        label: `${this.$t('pages.asctPolicyPage.label.address')}`,
        value: `${this.$t('pages.asctPolicyPage.value.address')}`
      },
      {
        label: `${this.$t('pages.asctPolicyPage.label.phone')}`,
        value: `${this.$t('pages.asctPolicyPage.value.phone')}`
      },
      {
        label: `${this.$t('pages.asctPolicyPage.label.siteName')}`,
        value: `${this.$t('pages.asctPolicyPage.value.siteName')}`
      },
      {
        label: `${this.$t('pages.asctPolicyPage.label.servicePrice')}`,
        value: `${this.$t('pages.asctPolicyPage.value.servicePrice')}`
      },
      {
        label: `${this.$t('pages.asctPolicyPage.label.paymentMethod')}`,
        value: `${this.$t('pages.asctPolicyPage.value.paymentMethod')}`
      },
      {
        label: `${this.$t('pages.asctPolicyPage.label.paymentPeriod')}`,
        value: `${this.$t('pages.asctPolicyPage.value.paymentPeriod')}`
      }
    ];
  }
}
